import React from 'react';
import PropTypes from 'prop-types'

const CustomerEmojiBackground = ({
  id = 'CustomerEmojiBackground',
  ...props
}) => {
  const maskId = `${id}-mask`;

  return (
    <svg width="60px" height="60px" viewBox="0 0 60 60" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g>
          <g>
            <mask id={maskId} fill="white">
              <circle cx="30" cy="30" r="30" />
            </mask>

            <circle fill="#F6F6F6" cx="30" cy="30" r="30" />

            <polygon
              fillOpacity="0.05"
              fill="#000000"
              mask={`url(#${maskId})`}
              points="29.9915254 30 59.9830508 69.7004063 -1.83840766e-12 69.7004063"
             />
          </g>
        </g>
      </g>
    </svg>
  );
};

CustomerEmojiBackground.propTypes = {
  id: PropTypes.string
};

export default CustomerEmojiBackground;
